import { createTheme } from '@mui/material/styles';

const Theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#15887f",
      contrastText: "#f8f8f6"
    },
    secondary: {
      main: "#124477"
    },
    background: {
      default: "#ffffff",
      paper: "#f8f8f6"
    },
    text: {
      primary: '#28282b',
      secondary: '#6c6e6d'
    }
  },
  typography: {
    fontFamily: [
      'Inter'
    ].join(','),
  }
});

export default Theme;